module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor13-bd7f04fb3b51d9be13de92cf7c1f8412.png";